const { Input } = require("antd");
const { Link } = require("react-router-dom");


export const HandleDynamicValues = (templatePreview, dynamicValues, setNewMessage) => {
    if (dynamicValues?.length > 0) {
        const bodyComponent = templatePreview?.components?.find(component => component.type === "BODY");
        const text = bodyComponent?.text;
        let updatedText = text;
        dynamicValues.forEach((item, index) => {
            updatedText = updatedText?.replace(`{{${index + 1}}}`, item);
        });
        setNewMessage(updatedText);
    }
}


export const HandleTemplateChange = (value, setMediaLink, setTemplateName, setTemplateKey, templates, setTemplateCategory, setTemplateLanguage,
    setTemplatePreview, setTemplate, setTemplateInputs, setTemplateUrlInputs, setDynamicValues, setDynamicUrlButton, initialBodyValues, initialButtonValues) => {
    // console.log('value', value);
    setTemplateName && setTemplateName(value);
    setTemplateKey && setTemplateKey(prevKey => prevKey + 1);
    const template = templates?.find((item) => item.name === value);
    // console.log('Selected Template:', template);
    setTemplateCategory && setTemplateCategory(template?.category)
    setTemplateLanguage && setTemplateLanguage(template?.language)
    setTemplatePreview && setTemplatePreview(template);
    const { header, body, footer, buttons } = extractTemplateSections(template);
    setTemplate({ header, body, footer, buttons });

    const templateBodyDynamicValue = body?.text?.match(/{{\d+}}/g);
    if (templateBodyDynamicValue) {
        const inputs = generateInputsForDynamicValues(templateBodyDynamicValue, setDynamicValues, initialBodyValues);
        setTemplateInputs(inputs);
        // If initial values provided, populate the state
        if (initialBodyValues?.length > 0) {
            setDynamicValues([...initialBodyValues]);
        }
    } else {
        setTemplateInputs([]);
    }

    if (buttons?.buttons) {
        const urlInputs = generateUrlInputs(buttons?.buttons, setDynamicUrlButton, initialButtonValues);
        setTemplateUrlInputs(urlInputs);
        // If initial button values provided, populate the state
        if (initialButtonValues?.length > 0) {
            setDynamicUrlButton([...initialButtonValues]);
        }
    } else {
        setTemplateUrlInputs([]);
    }
}


export const extractTemplateSections = (template) => {
    let header = null, body = null, footer = null, buttons = null;
    template?.components?.forEach(section => {
        switch (section.type) {
            case "HEADER":
                header = section;
                break;
            case "BODY":
                body = section;
                break;
            case "FOOTER":
                footer = section;
                break;
            case "BUTTONS":
                buttons = section;
                break;
            default:
                break;
        }
    });
    return { header, body, footer, buttons };
}

const generateInputsForDynamicValues = (dynamicValues, setDynamicValues, initialValues) => {
    return dynamicValues.map((placeholder, index) => (
        <Input
            key={index}
            type="text"
            placeholder={`Enter value for ${placeholder}`}
            defaultValue={initialValues?.[index] || ''}
            onChange={(e) => handleInputChange(index, e.target.value, setDynamicValues)}
        />
    ));
}

const generateUrlInputs = (urlButtons, setDynamicUrlButton, initialValues) => {
    return urlButtons.map((item, index) => {
        const isDisabled = !item.hasOwnProperty('example');
        if (!isDisabled) {
            return (
                <div key={index}>
                    <Link>{item.url}</Link>
                    <Input
                        type="text"
                        placeholder={`Your "${item.text}" Button Value`}
                        defaultValue={initialValues?.[index] || ''}
                        onChange={(e) => handleUrlButton(index, e.target.value, setDynamicUrlButton)}
                        disabled={isDisabled}
                    />
                </div>
            );
        }
        return null;
    })
        .filter(Boolean); // Remove null values
};


const handleInputChange = (index, value, setDynamicValues) => {
    setDynamicValues(prevValues => {
        const updatedValues = [...prevValues];
        updatedValues[index] = value;
        return updatedValues;
    });

};

const handleUrlButton = (index, value, setDynamicUrlButton) => {
    setDynamicUrlButton(prevValues => {
        const updatedValues = [...prevValues];
        updatedValues[index] = value;
        return updatedValues;
    });
};

// Language options with transliteration support
export const languages = [
    { value: 'en_US', label: 'English (US)', transLang: 'en' },
    { value: 'en_GB', label: 'English (UK)', transLang: 'en' },
    { value: 'hi', label: 'Hindi', transLang: 'hi' },
    { value: 'gu', label: 'Gujarati', transLang: 'gu' },
    { value: 'es', label: 'Spanish', transLang: 'es' },
    { value: 'fr', label: 'French', transLang: 'fr' },
    { value: 'de', label: 'German', transLang: 'de' },
    { value: 'pt_BR', label: 'Portuguese (Brazil)', transLang: 'pt' },
    { value: 'ar', label: 'Arabic', transLang: 'ar' },
    { value: 'bn', label: 'Bengali', transLang: 'bn' },
    { value: 'ta', label: 'Tamil', transLang: 'ta' },
    { value: 'te', label: 'Telugu', transLang: 'te' },
    { value: 'kn', label: 'Kannada', transLang: 'kn' },
    { value: 'ml', label: 'Malayalam', transLang: 'ml' },
    { value: 'mr', label: 'Marathi', transLang: 'mr' },
    { value: 'pa', label: 'Punjabi', transLang: 'pa' },
    { value: 'or', label: 'Odia', transLang: 'or' },
    { value: 'as', label: 'Assamese', transLang: 'as' },
    { value: 'ur', label: 'Urdu', transLang: 'ur' }
];